export enum TaxonomyEnum {
  EVALUATOR = 'Evaluator',
  ANALYST = 'Analyst',
  PRACTITIONER = 'Practitioner',
}
